export default "__VITE_ASSET__BuC3s5o6__"